import useStyles from './Content.styled'

export const useContent = props => {
	const {
		withImage,
		image,
		text,
		buttonText,
		buttonLink,
		buttonAction,
		extraShortcuts,
		onImageClick,
		onTextClick,
		onButtonClick,
		textEditable,
		onTextChange,
		buttonTextEditable,
		onButtonTextChange,
		textConfig,
		buttonTextConfig,
		textKey,
		buttonTextKey,
		mobileAlignment,
		mobileButtonWidth,
		onClick,
	} = props
	const { classes, cx } = useStyles(props, { props })

	return [
		{
			classes,
			cx,
			withImage,
			image,
			mobileAlignment,
			mobileButtonWidth,

			text,
			textConfig,
			buttonTextConfig,
			buttonText,
			buttonLink,
			buttonAction,
			extraShortcuts,
			textEditable,
			buttonTextEditable,
			textKey,
			buttonTextKey,
		},
		{
			handleImageClick: onImageClick,
			handleTextClick: onTextClick,
			handleButtonClick: onButtonClick,
			handleTextChange: onTextChange,
			handleButtonTextChange: onButtonTextChange,
			handleClick: onClick,
		},
	]
}
